import { DefaultTheme } from "styled-components";
import { dark as darkAlert } from "../components/Alert/theme";
import { dark as darkCard } from "../components/Card/theme";
import { dark as darkPancakeToggle } from "../components/PancakeToggle/theme";
import { dark as darkRadio } from "../components/Radio/theme";
import { dark as darkToggle } from "../components/Toggle/theme";
import { dark as darkNav } from "../widgets/Menu/theme";
import { dark as darkModal } from "../widgets/Modal/theme";
import { dark as darkTooltip } from "../components/Tooltip/theme";
import base from "./base";
import { darkColors } from "./colors";

const darkTheme: DefaultTheme = {
  ...base,
  isDark: true,
  alert: darkAlert,
  colors: darkColors,
  shadows: {
    ...base.shadows,
    active: "0px 0px 0px 1px #5FCB82, 0px 0px 4px 8px rgba(95,203,130,0.2)",
    success: "0px 0px 0px 1px #5FCB82, 0px 0px 0px 4px rgba(95,203,130,0.2)",
    focus: "0px 0px 0px 1px #5FCB82, 0px 0px 0px 4px rgba(95,203,130,0.2)",
    warning: "0px 0px 0px 1px #CBB677, 0px 0px 0px 4px rgba(203,182,119,0.2)",
    danger: "0px 0px 0px 1px #F66473, 0px 0px 0px 4px rgba(246,100,115,0.2)",
  },
  card: darkCard,
  toggle: darkToggle,
  nav: darkNav,
  modal: darkModal,
  pancakeToggle: darkPancakeToggle,
  radio: darkRadio,
  tooltip: darkTooltip,
};

export default darkTheme;
